import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorTileId,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput/index.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import {
  selectTargetAccumulatorScheduleData,
  selectTargetAccumulatorScheduleFieldValidation,
  selectTargetAccumulatorScheduleTable,
} from '@/store/targetAccumulator/selectors.ts';
import type { AccumulatorScheduleLine } from '@/store/targetAccumulator/state.ts';

const EkiDown = ({ legId }: { legId: string }) => {
  const tileId = useTargetAccumulatorTileId();
  const ekiDown = useAppSelector((state) => selectTargetAccumulatorScheduleTable(state, tileId, legId)?.ekiDown);
  const isModified = useAppSelector(
    (state) =>
      selectTargetAccumulatorScheduleData(state, tileId).scheduleCustomFields?.[legId]?.includes('EkiDown') ?? false,
  );
  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();
  const { sgwtWebAnalytics } = useSgwtWidgets();
  const { validation } = useAppSelector((state) =>
    selectTargetAccumulatorScheduleFieldValidation(state, tileId, legId, 'stepDownString'),
  );

  const handleEkiDown = (value: number | undefined) => {
    sgwtWebAnalytics?.trackEvent(
      'Target Accumulator',
      'Schedule ekiDown changed',
      isDefined(value) ? String(value) : 'null',
    );

    return checkTargetAccumulatorWithTradeCapture({
      schedule: { [legId]: { ekiDown: isDefined(value) ? value : null } as AccumulatorScheduleLine },
    });
  };

  return (
    <div style={{ maxWidth: '5rem' }}>
      <TradeCaptureValidationWrapper validation={validation}>
        <SgNumberInput
          valuePosition="start"
          selectAllOnFocus
          className={isModified ? 'text-info' : ''}
          value={isDefined(ekiDown) ? ekiDown : undefined}
          maxDecimals={9}
          onChange={handleEkiDown}
          size="sm"
          data-e2e="ekiDown"
          data-e2e-is-modified={isModified}
        />
      </TradeCaptureValidationWrapper>
    </div>
  );
};

export default EkiDown;
